import { render } from "./ChildrenContainerEditorCmp.vue?vue&type=template&id=00a30000"
import script from "./ChildrenContainerEditorCmp.vue?vue&type=script&lang=js"
export * from "./ChildrenContainerEditorCmp.vue?vue&type=script&lang=js"

import "./ChildrenContainerEditorCmp.vue?vue&type=style&index=0&id=00a30000&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__